import { render, staticRenderFns } from "./AttributeHistory.vue?vue&type=template&id=71281644&scoped=true&"
import script from "./AttributeHistory.vue?vue&type=script&lang=js&"
export * from "./AttributeHistory.vue?vue&type=script&lang=js&"
import style0 from "./AttributeHistory.vue?vue&type=style&index=0&id=71281644&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71281644",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VCard,VCardText,VIcon,VMenu})
